interface Props {
  className?: string;
}

export const BlogIcon = ({ className }: Props) => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M28.813 10.1539L23.2267 4.56886C23.041 4.38309 22.8205 4.23573 22.5778 4.13519C22.3351 4.03466 22.075 3.98291 21.8123 3.98291C21.5497 3.98291 21.2895 4.03466 21.0469 4.13519C20.8042 4.23573 20.5837 4.38309 20.398 4.56886L4.98421 19.9826C4.79768 20.1677 4.6498 20.3879 4.54916 20.6306C4.44852 20.8733 4.39712 21.1336 4.39796 21.3964V26.9826C4.39796 27.513 4.60867 28.0217 4.98375 28.3968C5.35882 28.7719 5.86753 28.9826 6.39796 28.9826H27.398C27.6632 28.9826 27.9175 28.8773 28.1051 28.6897C28.2926 28.5022 28.398 28.2478 28.398 27.9826C28.398 27.7174 28.2926 27.463 28.1051 27.2755C27.9175 27.088 27.6632 26.9826 27.398 26.9826H14.813L28.813 12.9826C28.9987 12.7969 29.1461 12.5764 29.2466 12.3337C29.3472 12.091 29.3989 11.8309 29.3989 11.5682C29.3989 11.3056 29.3472 11.0454 29.2466 10.8028C29.1461 10.5601 28.9987 10.3396 28.813 10.1539ZM17.398 10.3964L19.4842 12.4826L8.89796 23.0689L6.81171 20.9826L17.398 10.3964ZM6.39796 26.9826V23.3964L9.98421 26.9826H6.39796ZM12.398 26.5689L10.313 24.4826L20.898 13.8964L22.9842 15.9826L12.398 26.5689ZM24.398 14.5689L18.813 8.98261L21.813 5.98261L27.398 11.5689L24.398 14.5689Z"
      fill="currentColor"
    />
  </svg>
);
